import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import auth from "./Home/auth";

import 'bootstrap/dist/css/bootstrap.min.css';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/:id" component={auth} />
          <Route exact path="/" component={auth} />
        </Switch>
      </Router>
    );
  }
}

export default App;